//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import acornBrokenImage from '@images/acorn-broken.svg';
import trackingParamsInlineEditorTemplate from '@partials/tracking-params/tracking-params-inline-editor.html';

import _ from "js/underscore-mixins";

(function() {
  const curalate = angular.module('curalate');

  curalate.directive('trackingParamsInlineEditor', [
    'SessionVarsService',
    'TrackingParamsService',
    function(
            SessionVarsService,
            TrackingParamsService,
        ) {
      return {
        restrict: 'E',
        scope: {
          product: '=',
          originalParams: '=params',
          onSave: '&',
          onCancel: '&',
          shouldShowParamsError: '<',
        },
        transclude: true,
        template: trackingParamsInlineEditorTemplate,
        controllerAs: '$ctrl',
        controller: ['$scope', function($scope) {
          this.model = {
            product: angular.copy($scope.product),
            params: TrackingParamsService.sortParams(angular.copy($scope.originalParams)),
          };

          this.acornBrokenImage = acornBrokenImage;
          this.trackingParamsv2Enabled = SessionVarsService.isFeatureEnabled('url_tracking_params_v2');
          this.hasConfigurePermission = TrackingParamsService.hasConfigurePermission;

          this.anyGroupsInUse = _(this.model.params.paramGroups).some((paramGroup) => {
            return paramGroup.inUse && paramGroup.params.length > 0;
          });

          this.onSave = function() {
                        // just copy the paramsGroups, reassigning the params won't propagate up
            $scope.originalParams.paramGroups = angular.copy(this.model.params.paramGroups);
            $scope.product.destinationUrl = angular.copy(this.model.product.destinationUrl);
            $scope.onSave();
          };

          this.onCancel = function() {
            $scope.onCancel();
          };

          this.updateParams = (paramToUpdate, associatedParamGroup, updatedValue) => {
            const allParamGroups = this.model.params.paramGroups;
            const paramGroupIndex = allParamGroups.findIndex(existingParamGroup => existingParamGroup.name === associatedParamGroup.name);
            const paramIndex = allParamGroups[paramGroupIndex].params.findIndex(existingParam => existingParam.label === paramToUpdate.label);
            this.model.params.paramGroups[paramGroupIndex].params[paramIndex].value = updatedValue;
          };
        }],
      };
    },
  ]);
})();
